import axios from 'axios';

async function listPosts(companyId, page) {
  const response = await axios.get(`/companies/${companyId}/posts?page=${page}`);

  return response.data;
}

async function createPost(companyId, data) {
  const response = await axios.post(`/companies/${companyId}/posts`, data);

  return response.data;
}

async function deletePost(companyId, postId) {
  const response = await axios.delete(`/companies/${companyId}/posts/${postId}`);

  return response.data;
}

async function updatePost(companyId, postId, data) {
  const response = await axios.put(`/companies/${companyId}/posts/${postId}`, data);

  return response.data;
}

const postService = {
  createPost,
  deletePost,
  listPosts,
  updatePost,
}

export default postService;
